import React from 'react';
import useFetch from '../../effects/useFetch.effect';

import Episodes from '../../components/episodes/Episodes';
import Spinner from '../../components/spinner/Spinner';
import PodcastImage from '../../components/podcast-image/PodcastImage';
import PageTitle from '../../components/page-title/PageTitle';
import PodcastRow from '../../components/podcast-row/PodcastRow';
import SubscribeButton from '../../components/subscribe-button/SubscribeButton';

import { PodcastInfo, Subtitle, PodcastContainer } from './Podcast.styles';

import { data } from './exampleData';

const PodcastPage = ({ match }) => {
  const { podcastId } = match.params;

  const { data, loading } = useFetch(
    `/.netlify/functions/listennotes?url=podcasts/${podcastId}`
  );

  if (loading) return <Spinner />;
  const { title, description, publisher, image, id } = data;

  return (
    <PodcastContainer>
      <PageTitle>{title}</PageTitle>
      <PodcastInfo>
        <div style={{ position: 'relative', maxWidth: '200px' }}>
          <PodcastImage url={image} alt="Podcast logo" />
          <SubscribeButton
            title={title}
            publisher={publisher}
            thumbnail={image}
            id={id}
          />
        </div>
        <div>
          <Subtitle>{publisher}</Subtitle>
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </div>
      </PodcastInfo>
      <Episodes podcastData={data} />
      <PodcastRow title="Similar Podcasts" podcastID={id} />
    </PodcastContainer>
  );
};

export default PodcastPage;
